import type { DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweet } from './discoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweet';
import type { DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetType } from './discoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetType';

/**
 * 참조된 트윗 정보 (답글, 인용, 리트윗인 경우)
 */
export type DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweet = {
  /** 참조된 트윗 ID */
  id?: string;
  /** 참조된 트윗 요약 정보 (순환 참조 방지) */
  tweet?: DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweet;
  type?: DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetType;
};
